import { isValidTenant } from "configs/tenantConstants";
import capitalize from "lodash/capitalize";

import { DEFAULT_TENANT } from "@vega-core/constants/tenant";
import { getAppConfig } from "@vega-core/utils/appConfig";

const config = getAppConfig();

export const isLocal = () => window.location.hostname === "localhost";
export const isTest = config.mode === "test";
export const isDev = config.mode === "development";
export const isUat = config.mode === "uat";
export const isProd = config.mode === "prod";

export function getEnvironment(): "dev" | "local" | "prod" | "test" | "uat" {
  if (isDev) return "dev";

  if (isTest) return "test";

  if (isUat) return "uat";

  if (isProd) return "prod";

  return "local";
}

export const isLocalApi =
  import.meta.env.VITE_REACT_APP_API_URL?.includes("localhost") ?? false;

export const isGPPortal = import.meta.env.VITE_PORTAL_TYPE === "gp";

export const isLPPortal = import.meta.env.VITE_PORTAL_TYPE === "lp";

export const isLPCoInvestPortal =
  import.meta.env.VITE_PORTAL_TYPE === "lp-co-invest";

export const isGPCoInvestPortal =
  import.meta.env.VITE_PORTAL_TYPE === "gp-co-invest";

// TODO: delete isLPCoInvestPortal after migrating to this function. Needed for testing
export const getIsLPCoInvestPortal = () =>
  import.meta.env.VITE_PORTAL_TYPE === "lp-co-invest";

// TODO: delete isGPCoInvestPortal after migrating to this function. Needed for testing
export const getIsGPCoInvestPortal = () =>
  import.meta.env.VITE_PORTAL_TYPE === "gp-co-invest";

export const getBaseURL = () => window.location.origin;

export const isMSW = import.meta.env.VITE_MSW;

export const isF2F = import.meta.env.VITE_IS_F2F;

export const isLocalSession = import.meta.env.VITE_LOCAL_SESSION;

const getPortalEventOriginName = (): string => {
  const portalType = import.meta.env.VITE_PORTAL_TYPE;
  const portalNames: Record<string, string> = {
    gp: "GP-Portal",
    lp: "LP-Portal",
    "gp-co-invest": "GP-CoInvest-Portal",
    "lp-co-invest": "LP-CoInvest-Portal",
    "subscription-templates": "Subscription-Templates",
  };

  return portalType ? portalNames[portalType] : "Unknown-Portal";
};

export const getEventOrigin = (): string => {
  const tenant = isValidTenant(import.meta.env.VITE_TENANT)
    ? import.meta.env.VITE_TENANT
    : DEFAULT_TENANT;
  const tenantName = capitalize(tenant);

  return `${tenantName}-${getPortalEventOriginName()}`;
};
